import MainModal from '@/common/components/base/modal/Modal.tsx';
import { MainModalProps } from '@/common/components/base/modal/Modal.type.ts';
import { Box, Center } from 'styled-system/jsx';
import TitleDescription from '@/common/components/base/typography/TitleDescription.tsx';
import Typography from '@/common/components/base/typography/Typography.tsx';
import Button from '@/common/components/base/button/Button.tsx';
import NetworkErrorIcon from '@/common/assets/icons/networkErrorIcon.svg?react';

export default ({
  open,
  closeModal,
  retryFunction,
}: MainModalProps & { retryFunction: () => void }) => {
  return (
    <MainModal open={open} closeModal={closeModal}>
      <NetworkErrorModal retryFunction={retryFunction} />
    </MainModal>
  );
};

const NetworkErrorModal = ({
  retryFunction,
}: {
  retryFunction: () => void;
}) => {
  return (
    <Box>
      <TitleDescription mb="1rem">متصل نبودن به اینترنت</TitleDescription>
      <Center mb="1.5rem">
        <NetworkErrorIcon />
      </Center>
      <Typography mb="2rem" textStyle="b2">
        عدم اتصال به اینترنت؛ لطفا اینترنت خود را بررسی کرده و مجدداً تلاش کنید.
      </Typography>
      <Button mb="1rem" onClick={() => retryFunction()} fullWidth>
        تلاش مجدد
      </Button>
    </Box>
  );
};
